// 手机端判断各个平台浏览器及操作系统平台
// const isClient = process.client
let isPc = false
let isAndroid = false
let isIos = false
let isWeChat = false
// if (isClient) {
isPc = !/Android|webOS|iPhone|iPod|iOS|iPad|BlackBerry|MicroMessenger/i.test(
  navigator && navigator.userAgent
)
isAndroid = /android/i.test(navigator && navigator.userAgent)
isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator && navigator.userAgent)
isWeChat = /MicroMessenger/i.test(navigator && navigator.userAgent)
// }

export default {
  isPc,
  isAndroid,
  isIos,
  isWeChat
}
